import './StaffLoginView.css'

import { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router'
import { useAtomValue, useSetAtom } from 'jotai'

import { staff } from '../../store'

import { Button } from '../../components/Button'
import { FieldError } from '../../components/FieldError'
import { Form } from '../../components/Form'
import { TextField } from '../../components/TextField'
import { useFormFieldErrors } from '../../hooks/useFormFieldErrors'

export function StaffLoginView() {
  const [formValue, setFormValue] = useState({ email: '', password: '' })
  const isLoading = useAtomValue(staff.staffLoginIsLoadingAtom)
  const authStatus = useAtomValue(staff.staffSessionStatusAtom)
  const login = useSetAtom(staff.staffLoginAtom)
  const navigate = useNavigate()
  const location = useLocation()

  const serverErrors = useFormFieldErrors(staff.staffLoginIssuesAtom)

  useEffect(() => {
    if (authStatus === 'authenticated') {
      const from = (location.state as { from?: string })?.from || '/staff/dashboard'
      navigate(from.startsWith('/staff') ? from : '/staff/dashboard', { replace: true })
    }
  }, [authStatus, navigate, location.state])

  const handleSubmit = () => {
    login({
      email: formValue.email,
      password: formValue.password,
    })
  }

  return (
    <Form
      className="staff-login-view"
      value={formValue}
      onChange={setFormValue}
      onSubmit={handleSubmit}
      flags={serverErrors}
    >
      <p className="staff-login-view__eyebrow">Staff</p>
      <h2 className="staff-login-view__title">Sign in to the console</h2>
      <p className="staff-login-view__subtitle">
        Operations access for running Revel Club. Member accounts cannot sign in here.
      </p>

      <TextField
        name="email"
        label="Email"
        placeholder="Enter your staff email"
        required
        email
        disabled={isLoading}
      />
      <FieldError
        name="email"
        text={{
          required: 'Email is required',
          email: 'Please enter a valid email',
          networkError: 'Network error — please try again',
        }}
      />

      <TextField
        name="password"
        label="Password"
        kind="password"
        placeholder="Enter your password"
        required
        disabled={isLoading}
      />
      <FieldError
        name="password"
        text={{
          required: 'Password is required',
          invalidCredentials: 'Email or password unrecognized',
        }}
      />

      <div className="staff-login-view__actions">
        <Button type="submit" kind="primary" disabled={isLoading}>
          {isLoading ? 'Signing in…' : 'Sign in'}
        </Button>
      </div>
    </Form>
  )
}
